import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initLoadMorePagination from '../sections/collection/initLoadMorePagination';

ready(() => {
  initLoadMorePagination();
});

onShopifySectionLoad(() => {
  initLoadMorePagination();
});
